import { Filter, RotateCcw, Search } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";

type FilterCardProps = {
  title: string;
  badge?: number;
  children: React.ReactNode;
  onFilter?: () => void;
  onReset?: () => void;
  showFilterButton?: boolean;
};

export function FilterCard({
  title,
  badge,
  children,
  onFilter,
  onReset,
  showFilterButton = true,
}: FilterCardProps) {
  const { t } = useTranslation();

  return (
    <div className="header-ribbon filter-panel relative isolate rounded-[var(--radius-card)] mb-6">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-4 py-3 sm:px-5">
        <div className="flex items-center gap-2">
          <Filter size={16} className="text-primary" />
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
          {badge !== undefined && (
            <span className="flex h-6 min-w-6 items-center justify-center rounded-md bg-purple-soft px-1.5 text-xs font-semibold text-purple">
              {badge}
            </span>
          )}
        </div>
        {(showFilterButton || onReset) && (
          <div className="flex items-center gap-2">
            {showFilterButton && (
              <button
                type="button"
                onClick={onFilter}
                className="flex items-center justify-center gap-2 rounded-lg bg-primary px-3.5 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
              >
                <Search size={16} />
                {t.safecheck.filter}
              </button>
            )}
            {onReset && (
              <button
                type="button"
                onClick={onReset}
                className="flex items-center justify-center gap-2 rounded-lg border border-border bg-card px-3.5 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent/20 hover:border-accent"
              >
                <RotateCcw size={16} />
                {t.safecheck.reset}
              </button>
            )}
          </div>
        )}
      </div>
      <div className="p-4 sm:p-5">{children}</div>
    </div>
  );
}
